// extracted by mini-css-extract-plugin
module.exports = {"logo":"ThankYouPage_logo__22PyH","page":"ThankYouPage_page__2pwyA","link":"ThankYouPage_link__2CuuN"};